import './entry.less';
import Vue from 'vue';
import Vuex from 'vuex';
import  {mapActions, mapGetters , mapState} from 'vuex';
import debounce from 'lodash.debounce'
import storeConfig from '../components/pagesbuilder/store/store-config';
import PreviewComponentsManager from './dynamic-components/PreviewComponentsManager.vue';
import PreviewSectionsManager from './sections/PreviewSectionsManager.vue';
import CommonMain from '../components/pagesbuilder/CommonMain';
import PreviewElementsManager from "./elements/PreviewElementsManager";
import AdminNavigationTooltip from "./components/AdminNavigationTooltip";
import eventBus from '../commonjs/EventBus.vue';
import Notifications from "./components/Notifications";
import InactivityWatcher from "./components/InactivityWatcher";
import PopupNotifications from "./components/PopupNotifications";
import PreviewModeNotification from "./components/PreviewModeNotification";
import {getUrlParams} from "../commonjs/utils/UrlHandler";
import textSizesConfig from "../author/pagesbuilder/components/global-styling/components/textSizesConfig";
window.inactivitySettings = {inactiveTime:0.1, timeToAbort:60, messageDescription: "This session has been idle over its time limit. Please press OK now to continue your session or you will be disconnected in 60 seconds."};
import VeeValidate from "vee-validate";
import i18n from "@/vueTranslationPlugin";

Vue.use(VeeValidate);
Vue.use(i18n);

// Setup vue instance
window.pageBuilder = new Vue({
    el : "#pageTools",
    store: new Vuex.Store(storeConfig),
    mixins: [CommonMain,Notifications],
    computed : {
        ...mapState('pages',[
            'pageContext'
        ]),
        ...mapGetters('user',[
            'isLoggedIn'
        ]),
        ...mapState('UiInteractions', [
            'activeDevicePreview',
            'availableDevicePreviews',
        ]),
        ...mapState('siteTemplate', [
            'responsiveFontScale'
        ]),
        deviceBreakpoints: function () {
            const breakPoints = {};
            for (let device in this.availableDevicePreviews) {
                if (device !== 'desktop' && typeof this.availableDevicePreviews[device]['mediaQuery'] === 'object') {
                    breakPoints[device] = this.availableDevicePreviews[device]['mediaQuery'];
                }
            }
            return breakPoints;
        }
    },
    mounted () {
        if (this.isLoggedIn) {
            setTimeout ( () => {
                this.initNotificationsInterval();
            },1000)
        }

        // <===================================>
        if(document.location.pathname.indexOf("/pages/home") === 0 && this.pageContext.params && this.pageContext.params["from"] && this.pageContext.params["from"] == "footer"){
            $("body, html").animate({scrollTop:$("#pageFooter").offset().top},1500);
        }

        if ($.getURLvar("searchtext")) {
            //break away from thread to finish rendering first

            window.setTimeout(function () {
                this.$wrapper.find(".-search-input , .js-input-search-by-term").val($.getURLvar("searchtext")).trigger("keyup");
            }.bind(this),1);
        }

        if (!isLoadedInIframe('learnworlds')) {
            // continue
        } else if (isLoadedInIframe('learnworlds') && this.pageContext.params["preview"]) { // If page is different but viewed with page preview
            // continue
        } else if (isLoadedInIframe('learnworlds') && document.location.pathname.indexOf("specific-terms") > -1) { // If specific-terms page is viewed from any other page
            // continue
        } else if (isLoadedInIframe('learnworlds') && document.location.pathname.indexOf("terms") > -1) { // If terms page is viewed from any other page
            // continue
        } else if (isLoadedInIframe('learnworlds') && document.location.pathname.indexOf("cookies") > -1) { // If cookies page is viewed from any other page
            // continue
        } else if (isLoadedInIframe('learnworlds') && document.location.pathname.indexOf("affiliate-program-terms") > -1) { // If cookies page is viewed from any other page
            // continue
        } else {
            // redirect
            top.location = document.location.href;
        }

        if (isLoadedInIframe('learnworlds') && top.location.pathname.indexOf("pages_preview") !== -1) {
            // allow
        } else if (document.location.pathname.indexOf("/payment") === 0 && typeof $.getURLvar("product_id") == "undefined") {
            window.location.href = "/?start=1";
        } else if (document.location.pathname.indexOf("/thankyou") === 0 && typeof $.getURLvar("after_purchase") == "undefined") {
            window.location.href = "/?start=1";
        }


        // <===================================>

    },
    methods: {
        ...mapActions('topbar',[
            'setSchoolTopbarData'
        ]),
        ...mapActions('footer',[
            'setSchoolFooterData'
        ]),
        ...mapActions('user',[
            'setUnreadInboxMessages'
        ]),
        ...mapActions('UiInteractions', [
            'setActiveDevicePreview'
        ]),
        $t (translationKey) {
            return window.LWTranslate.get(translationKey);
        },
        addWindowListeners () {
            window.addEventListener('resize', this.onWindowResize);
        },
        init () {

            let pageWrapper = document.querySelector("#pageContent");
            let urlParams = getUrlParams(document.location.href);
            //load products to setup store and interface editing tools
            let initActions = [];
            initActions.push(this.loadProducts());
            // initActions.push(this.getLinksManagerData());
            // initActions.push(this.getArticles());
            initActions.push(this.setSchoolTopbarData(window.globalTopbar));
            initActions.push(this.setSchoolFooterData(window.globalFooter));
            initActions.push(this.initializePageData(window.pageState));
            //initActions.push(this.setPageContext(this.getContextParams()));            
            if(urlParams.product_id){
                urlParams['product_type'] = urlParams.type;
            }
            delete urlParams.type; //Delete from the params the type it is reserved for the context
            
            initActions.push(this.setPageContext( {...window.pageState,...urlParams}));

            Promise.all(initActions).then(()=>{
                //State sections should be initiated before the component & element states
                this.initSectionsManager(pageWrapper);
                // this.$nextTick(()=>{
                    this.initComponentsManager(pageWrapper);
                    this.initElementsManager(pageWrapper);
                    this.$nextTick(()=>{ // this is to trigger the activeDevicePreview watcher.TODO: It needs fixing because elements jump when classes change after initial render
                        this.updateActiveDevice(this.getUserDevice());
                        this.setRootFontSize(this.getUserDevice());
                    })
                // })
            });
        },
        getUserDevice () {
            const w = getViewPortWidth();
            let currentDevice = 'desktop';
            for (let [device, breakpoint] of Object.entries(this.deviceBreakpoints)) {
                if (w <= breakpoint.maxWidth && w >= breakpoint.minWidth) {
                    currentDevice = device;
                }
            }
            return currentDevice;
        },
        setRootFontSize (device) {
            const responsiveFontScale = this.responsiveFontScale;
            const baseFontSize = 10;
            let fontSize = baseFontSize * this.availableDevicePreviews[device]['fontScale'] / 100; // default value
            if (responsiveFontScale && responsiveFontScale[device]) {
                fontSize = baseFontSize * responsiveFontScale[device] / 100;
            }

            //console.log('Setting font size to: ', fontSize);
            document.documentElement.style.setProperty('font-size', fontSize + 'px');
        },
        updateActiveDevice (device) {
            if (device !== this.activeDevicePreview) {
                // console.log('Changing active device to: ', device);
                this.setActiveDevicePreview(device);
            }
        },
        onWindowResize: debounce(function () {
            this.checkViewportDimensions();
            this.updateActiveDevice(this.getUserDevice());
            this.setRootFontSize(this.getUserDevice());
        }, 150),
    },
    components : {
        PreviewComponentsManager,
        PreviewSectionsManager,
        PopupNotifications,
        InactivityWatcher,
        AdminNavigationTooltip,
        PreviewElementsManager,
        PreviewModeNotification,
    }
})


